import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Divider } from 'foundations-library/components'
import PDCMarkdown from 'pdc-markdown'

const useStyles = makeStyles((theme) => {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch'
        },
        sectionContainer: {
            display: 'flex',
            padding: '20px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '29px',
            alignSelf: 'stretch',
            '& .summary': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '10px',
                alignSelf: 'stretch',
                '& .header': {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    alignSelf: 'stretch'
                },
                '& ol': {
                    marginLeft: '18px'
                }
            }
        }
    }
})

interface SummaryInterface {
    [key: string]: {
        content: string
        title: string
        logo: string
    }
}

/**
 *
 */
const CallSummary = ({ summary }: { summary?: SummaryInterface }) => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            {
                summary && Object.entries(summary).map(([key, value], index) => {
                    const { content, title, logo } = value
                    return (
                        [<div key={`section-${key}`} className={classes.sectionContainer}>
                            <div className={'summary'}>
                                <div className={'header'}>
                                    <img src={logo} width={26} alt={`${title}-logo`} />
                                    <Typography variant='subtitle1'>
                                        {title}
                                    </Typography>
                                </div>
                                <div>
                                    <Typography variant='body2'>
                                        <PDCMarkdown>
                                            {content}
                                        </PDCMarkdown>
                                    </Typography>
                                </div>
                            </div>
                        </div>,
                        index !== (Object.keys(summary).length - 1) && <Divider key={`divider-${index}`} marginTop={0} marginBottom={0} />]
                    )
                })
            }
        </div>
    )
}

export default CallSummary
